import { IPromise } from 'angular';
import DjangoClient from '../../tn.django/django-client.service/djangoClient';
import { UserService } from '../../tn.user/service.tn.user';
import { BehaviorSubject } from 'rxjs';
import { FamilyId } from '../classes/Model/FontFamliy';

export enum TrialType {
    DESKTOP = 1,
    // not yet implemented in backend.
    // WEB = 2,
}

export interface IPostTrial {
    family_id: number;
    trial_type: TrialType;
}

export interface IDjangoTrial {
    id: number;
    family_id: number;
    family_name: string;
    file: string
    file_permalink_url: string;
    file_storage_url: string;
    trial_type: TrialType;
    user_id: number;
}

export interface ITrial extends IDjangoTrial {
    // upstream values not in the django model data.
    created_date?: Date;
    updated_date?: Date;
}

export function transformIDjangoTrialToITrial(
    djangoTrial: IDjangoTrial
): ITrial {
    return {
        ...djangoTrial,
        // created_date: new Date(djangoTrial.created),
        // updated_date: new Date(djangoTrial.updated_at),
    };
}

export type ITrialIdx = Record<FamilyId, ITrial>;

function toITrialByFamilyIdx(trials: ITrial[]): ITrialIdx {
    return trials.reduce<ITrialIdx>((acc, trial) => {
        acc[trial.family_id] = trial;
        return acc;
    }, {});
}

export class TrialService {
    static $inject = ['djangoClient', 'tn.user.service'];
    trials$: BehaviorSubject<ITrial[]> = new BehaviorSubject<ITrial[]>([]);
    trialByFamilyIdx$: BehaviorSubject<ITrialIdx> =
        new BehaviorSubject<ITrialIdx>({});
    constructor(
        protected djangoClient: DjangoClient,
        protected userService: UserService
    ) {
        if (this.userService.isLoggedIn()) {
            this.list();
        }

        this.userService.login$.subscribe(() => {
            this.list();
        });

        this.userService.logout$.subscribe(() => {
            this.trials$.next([]);
        });
    }

    // fetch trials for the current user.
    list(): IPromise<ITrial[]> {
        return this.djangoClient
            .getAllPages<IDjangoTrial>('/api/1/trials/')
            .then((data) => {
                const trials = data.results.map(transformIDjangoTrialToITrial);
                this.trials$.next(trials);
                this.trialByFamilyIdx$.next(toITrialByFamilyIdx(trials));
                return trials;
            });
    }

    get(id: number): IPromise<ITrial> {
        return this.djangoClient
            .get<IDjangoTrial>(`/api/1/trials/${id}`)
            .then((data) => {
                const trial = transformIDjangoTrialToITrial(data);
                // update cached trials.
                const trials = this.trials$.getValue();
                const idx = trials.findIndex((t) => t.id === id);
                if (idx != -1) {
                    trials[idx] = trial;
                }
                else {
                    trials.push(trial);
                }
                const trialByFamilyIdx = this.trialByFamilyIdx$.getValue();
                trialByFamilyIdx[trial.family_id] = trial;
                this.trials$.next(trials);
                this.trialByFamilyIdx$.next(trialByFamilyIdx);
                return trial;
            });
    }

    // start a new trial.
    post(postTrial: IPostTrial): IPromise<ITrial> {
        return this.djangoClient
            .post<IDjangoTrial, IPostTrial>('/api/1/trials/', postTrial)
            .then((data) => {
                const trial = transformIDjangoTrialToITrial(data);
                this.list();
                return trial;
            });
    }
}
